import { useMutation } from "@apollo/react-hooks";
import { useAsyncCallback } from 'react-use-async-callback';
import gql from "graphql-tag";
import { AsyncActionStatus } from '../../../shared/abstractStore';
import { deleteSubscriptionMutation, deleteSubscriptionMutationVariables } from '../generated/deleteSubscriptionMutation';
import { subscriptionFieldsFragment } from '../models/Subscription';

/**
 * Get a callback to delete a Subscription in the store.
 */
export function useDeleteSubscriptionCallback(): [(id: string) => Promise<void>, AsyncActionStatus] {
    const [mutationAction, { error }] = useMutation<deleteSubscriptionMutation, deleteSubscriptionMutationVariables>(
        gql`
            mutation deleteSubscriptionMutation ($id: ID!) {
                deleteSubscription(id: $id) {
                    ...subscriptionFields
                }
            }

            ${subscriptionFieldsFragment}
        `
    );

    // Wrap the mutation in a standard callback.
    const [action, { isExecuting, errors: actionErrors }] = useAsyncCallback(async (id: string) => {
        const result = await mutationAction({ variables: { id: id } });
        if (result.errors && result.errors.length) {
            throw result.errors;
        }
    }, [mutationAction]);

    return [action, { isExecuting: isExecuting, errors: error ? error.message : actionErrors }];
}
